import Header from '@/shared/components/Header';
import Footer from '@/shared/components/Footer';
import Templates from '@/widgets/index';
import { useState, useEffect } from 'react';
import styles from './styles.module.css';
import getDataLayer from '@/shared/functions/gtm';
import Head from "next/head";
import TagManager from 'react-gtm-module';
import ContenedorTitulo from '@/shared/components/ContenedorTitulo';

import { useAppContext } from '@pagegrowler_nextjs';
import Chartbeat from '@/shared/components/Chartbeat';
import MetaTags from '@/shared/components/MetaTags';
import MegaBannerDerecha from '@/shared/components/MegaBannerDerecha';
import PagegrowlerList from '@/widgets/Listado/Templates/PagegrowlerList';


function Seccion(props) {

	// estado booleano, para determinar si la data que se le envia a NotaDeSeccion, viene del servidor o del cliente
	const [conditionDataRender, setConditionDataRender] = useState(false);

	const LOAD_MORE = 12;

	const pg = useAppContext();
	const Pagegrowler = pg.pagegrowler;

	const [open, setOpen] = useState(false);

	let [data, setData] = useState([]);
	let [offset, setOffset] = useState(0);

	const [isLoading, setIsLoading] = useState(false);
	const [hideLoadMore, setHideLoadMore] = useState(false);

	let menues = props.menu ? props.menu : [];

	// Funcion que regresa las propiedades de properties con un valor por defecto en caso de no existir la misma.
	const handleValueProperties = () => {
		const { properties } = props;
		const valueDefaultProperties = {
			biography: "",
			category: "",
			email: "",
			gtmPublishedDate: "",
			hasVisiblePage: "",
			idImage: "",
			imageID: "",
			imageUrl: "",
			lastModified: "",
			modificatedAt: "",
			name: "",
			product: "",
			publishedDate: "",
			shortBiography: "",
			slug: "",
			twitter: "",
			type: "",
			_id: ""
		};

		return { ...valueDefaultProperties, ...properties };	
	};

const properties = handleValueProperties();

	const {
		content,
		pagination = {},
	} = { ...props };

	const description = `${properties.name} - El Litoral. Más en http://www.ellitoral.com . Noticias actualizadas las 24 horas.`
	const gtmObject = {
		_id: properties._id,
		publishedDate: properties.publishedDate,
		page_type: 'sección',
		nsSite: properties.nsSite,
		gtm_name: properties.name,
	};

	async function showMoreData() {
		setIsLoading(true);
		let res = await Pagegrowler.loadMoreData(LOAD_MORE, offset);
		if (res.content && res.content.length > 0) {
			setConditionDataRender(true);
			setData(prevState => [...prevState, ...res.content]);
			setOffset(offset + LOAD_MORE);
			setIsLoading(false);
		} else {
			setHideLoadMore(true);
		}
	}

	useEffect(() => {
		TagManager.dataLayer({ dataLayer: getDataLayer(gtmObject) });
		setOffset(pagination.limit + pagination.offset);
		setData(content);
	}, []);

	let dataLDJson = {
		"@context": "https://schema.org",
		"@type": "Organization",
		"name": "Diario El Litoral",
		"url": "https://www.ellitoral.com",
		"logo": {
			"@type": "ImageObject",
			"url": `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/header_logoellitoral.svg`,
			"width": 439,
			"height": 60
		},
		"sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://plus.google.com/+EllitoralArgentina"]
	};

	return (
		<>
			<Head>
				<title>
					{`${properties.name}  - Últimas Noticias  : : El Litoral - Noticias - Santa Fe - Argentina - ellitoral.com : :`}
				</title>
				<meta name='description' content={description} />
				<meta httpEquiv="refresh" content="600" />
				<meta name="og:url" property="og:url" content={process.env.NEXT_PUBLIC_DOMAIN_URL+'/seccion/'+ properties.url} />
				<meta name="og:image" property="og:image" content={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
				<meta name="og:title" property="og:title" content={properties.name} />
				<meta name="og:type" property="og:type" content="website" />
				<meta name="og:description" property="og:description" content={description} />
				<link rel="canonical" href={process.env.NEXT_PUBLIC_DOMAIN_URL + '/seccion/' + properties.url } />
				<link rel="image_src" href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
				<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(dataLDJson) }} />
				<MetaTags metas={props.meta} />
				<meta name="robots" content="max-image-preview:large" />
			</Head>
			<Chartbeat sections={properties} />
			<Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} />
			<div className={`${styles['parent']}`}>
				<div className={`${styles['main-container']}`}>
					{!props.preview && <Templates.BannerHorizontalChico bannerId={`top`} />}
					<ContenedorTitulo text={properties.name} />
					<div className={`${styles['grid-container']}`}>
						<div className={`${styles['detail-left']}`}>
							{data && (
								<Templates.NotasDeSeccion data={conditionDataRender ? data : content} />
							)}
							<div className={`${styles['btn-container']}`}>
								<button className={`${styles["btn"]} ${styles[hideLoadMore ? 'hide' : '']}`} disabled={isLoading} onClick={showMoreData}>
									<strong style={{ textTransform: 'uppercase' }}>VER MAS NOTAS - {properties.name} </strong>
								</button>
							</div>
						</div>
						<div className={`${styles['detail-right']}`}>
							<PagegrowlerList url='column-lilanews'/>
						</div>
					</div>

					<div className={`${styles['container-bannerHorizontal']}`}>
						<Templates.BannerHorizontalChico bannerId={`horizontal1`} />
					</div>

					<div className={`${styles['detail-full']}`}>
						<div className={`${styles['widget-block']}`}>
							<PagegrowlerList url='column-bottom-lilanews'/>
						</div>
					</div>

					<div className={`${styles['container-bannerHorizontal']}`}>
						<Templates.BannerHorizontalGrande bannerId={`horizontal2`} />
					</div>
				</div>
			</div>
			<div style={{ clear: 'both' }}>
				<Footer />
				{!props.preview && <MegaBannerDerecha customId={`lateralmega`} />}
			</div>
		</>
	);
}
export default Seccion;